import React, {useEffect} from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/about-breadcrumb.webp'
import Clients from "../Components/Clients";
import Cta from "../Components/Cta";
import heroImg from '../Images/about-hero.webp'
import { missionVisionData, stats, valuesData } from "../Data";
import SchemaMarkup from "../Components/SchemaMarkup";
import WebPageSchema from "../Schema/webPageSchema";
import createBreadcrumbSchema from "../Schema/breadcrumbSchema";

const About=()=>{
     useEffect(() => {
        document.title =
          "About Gurukrupa Wood Pvt. Ltd. | Packaging Experts";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Learn about Gurukrupa Wood Pvt. Ltd., trusted manufacturers of wooden pallets, boxes, crates & customised packaging solutions."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://gurukrupawood.com/about-us");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "About Gurukrupa Wood Pvt. Ltd. | Packaging Experts"
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Learn about Gurukrupa Wood Pvt. Ltd., trusted manufacturers of wooden pallets, boxes, crates & customised packaging solutions."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://gurukrupawood.com/about-us");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://gurukrupawood.com/about.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "About Gurukrupa Wood Pvt. Ltd. | Packaging Experts"
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Learn about Gurukrupa Wood Pvt. Ltd., trusted manufacturers of wooden pallets, boxes, crates & customised packaging solutions."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://gurukrupawood.com/about.webp"
        );
      }
      }, []);


     const { ref: statsRef, inView: statsInView } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

const schema = WebPageSchema({
    name: "About Gurukrupa Wood Pvt. Ltd.",
    url: "https://gurukrupawood.com/about-us",
    description:
      "Established in 2013, Gurukrupa Wood Pvt. Ltd. is a leading manufacturer and supplier of high-quality wooden packaging products."
  });

const breadcrumbSchema = createBreadcrumbSchema([
  {
    name: "Home",
    url: "https://gurukrupawood.com/"
  },
  {
    name: "About Us",
    url: "https://gurukrupawood.com/about-us"
  },
]);
    return(
        <>

      <SchemaMarkup data={schema} />
      <SchemaMarkup data={breadcrumbSchema} />
      
        <Breadcrumb
  pageName="About Us"
  bgImage={bgImg}
/>

        {/**ABOUT US SECTION */}
        <section className="about-intro-section container" ref={statsRef}>

  {/* LEFT */}
  <motion.div
    className="about-intro-left"
    initial={{ opacity: 0, x: -70 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.25 }}
  >

    <motion.h3
      className="section-subheading"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      ABOUT US
    </motion.h3>

    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 35 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.15,
        duration: 0.7,
      }}
      viewport={{ once: true }}
    >
      Quality Packaging, Delivered With Trust
    </motion.h2>

    <motion.p
      className="section-text"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.3,
        duration: 0.8,
      }}
      viewport={{ once: true }}
    >
      Established in 2013, Gurukrupa Wood Pvt. Ltd. is a leading manufacturer
      and supplier of high-quality wooden packaging products. With advanced
      infrastructure, skilled professionals, and a strong focus on quality, we
      deliver durable and customised packaging solutions that ensure safety,
      strength, and satisfaction. Driven by innovation and a commitment to
      excellence, we continuously evolve our processes to meet the dynamic
      demands of global logistics and industrial standards. Our expertise
      extends beyond manufacturing; we provide end-to-end support, from
      material selection and design optimization to specialized heat treatment
      and timely on-site delivery. By maintaining a vast inventory of seasoned
      timber and utilizing high-precision machinery, we guarantee consistent
      quality even for high-volume orders. At Gurukrupa Wood, we believe that
      the safety of your product is a reflection of our integrity, which is why
      we leave no stone unturned in ensuring that every crate, pallet, and box
      is built to endure the most challenging shipping environments worldwide.
    </motion.p>

  </motion.div>

  {/* RIGHT */}
  <motion.div
    className="about-intro-right"
    initial={{ opacity: 0, x: 70 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.25 }}
  >

    {/* IMAGE */}
    <motion.img
      src={heroImg}
      alt="Quality Packaging, Delivered With Trust | Gurukrupa Wood Pvt. Ltd."
      initial={{ scale: 1.08, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      transition={{
        duration: 1,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{ once: true }}
      whileHover={{
        scale: 1.03,
      }}
    />

    {/* STATS */}
    <motion.div
      className="about-stats"
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.15,
          },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >

      {stats.map((item, i) => (
        <motion.div
          className="about-stat-card"
          key={i}
          variants={{
            hidden: {
              opacity: 0,
              y: 40,
              scale: 0.92,
            },
            visible: {
              opacity: 1,
              y: 0,
              scale: 1,
            },
          }}
          transition={{
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1],
          }}
          whileHover={{
            y: -6,
            scale: 1.03,
          }}
        >

          {/* NUMBER */}
          <motion.h4
            className="card-heading"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              delay: 0.2 + i * 0.1,
              duration: 0.5,
            }}
            viewport={{ once: true }}
          >
            {statsInView && (
              <CountUp
                end={item.number}
                duration={3}
              />
            )}
            {item.suffix}
          </motion.h4>

          {/* TEXT */}
          <motion.p
            className="section-text"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              delay: 0.35 + i * 0.1,
              duration: 0.5,
            }}
            viewport={{ once: true }}
          >
            {item.title}
          </motion.p>

        </motion.div>
      ))}

    </motion.div>

  </motion.div>

</section>

        {/**MISSION VISION SECTION */}
       <section className="mission-section">

  <motion.div
    className="container"
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.18,
        },
      },
    }}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
  >

    {missionVisionData.map((item, i) => (
      <motion.div
        className="mission-card"
        key={i}
        variants={{
          hidden: {
            opacity: 0,
            y: 70,
          },
          visible: {
            opacity: 1,
            y: 0,
          },
        }}
        transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1],
        }}
        whileHover={{
          y: -10,
        }}
      >

        {/* ICON */}
        <motion.div
          className="mission-icon-wrapper"
          initial={{
            scale: 0,
            rotate: -12,
          }}
          whileInView={{
            scale: 1,
            rotate: 0,
          }}
          transition={{
            delay: 0.2 + i * 0.15,
            type: "spring",
            stiffness: 180,
            damping: 12,
          }}
          viewport={{ once: true }}
          whileHover={{
            rotate: 5,
            scale: 1.08,
          }}
        >
          <motion.img
            src={item.icon}
            alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
            whileHover={{
              scale: 1.08,
            }}
            transition={{ duration: 0.3 }}
          />
        </motion.div>

        {/* TITLE */}
        <motion.h4
          className="card-heading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.35 + i * 0.15,
            duration: 0.5,
          }}
          viewport={{ once: true }}
        >
          {item.title}
        </motion.h4>

        {/* DESCRIPTION */}
        <motion.p
          className="section-text"
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.45 + i * 0.15,
            duration: 0.6,
          }}
          viewport={{ once: true }}
        >
          {item.desc}
        </motion.p>

      </motion.div>
    ))}

  </motion.div>

</section>

        {/**VALUES SECTION */}
       <section className="values-section container">

  {/* HEADING */}
  <motion.h3
    className="section-subheading"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
  >
    OUR VALUES
  </motion.h3>

  <motion.h2
    className="section-heading"
    initial={{ opacity: 0, y: 35 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      delay: 0.15,
      duration: 0.75,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true }}
  >
    What Drives Us Every Day
  </motion.h2>

  {/* GRID */}
  <motion.div
    className="values-grid"
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.14,
        },
      },
    }}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.15 }}
  >

    {valuesData.map((item, i) => (
      <motion.div
        className="values-card"
        key={i}
        variants={{
          hidden: {
            opacity: 0,
            y: 55,
            scale: 0.94,
          },
          visible: {
            opacity: 1,
            y: 0,
            scale: 1,
          },
        }}
        transition={{
          duration: 0.75,
          ease: [0.22, 1, 0.36, 1],
        }}
        whileHover={{
          y: -10,
        }}
      >

        {/* IMAGE */}
        <motion.div
          style={{
            overflow: "hidden",
          }}
        >
          <motion.img
            src={item.img}
            alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
            whileHover={{
              scale: 1.08,
            }}
            transition={{
              duration: 0.5,
            }}
          />
        </motion.div>

        {/* TITLE */}
        <motion.h4
          className="card-heading"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{
            delay: 0.2 + i * 0.08,
            duration: 0.5,
          }}
          viewport={{ once: true }}
          whileHover={{
            letterSpacing: "0.4px",
          }}
        >
          {item.title}
        </motion.h4>

      </motion.div>
    ))}

  </motion.div>

</section>

         {/**OUR VALUABLE CLIENTS SECTION */}
     <Clients />

     {/**CTA SECTION */}
     <Cta/>
        </>
    )
}
export default About;